import React from 'react'
import classnames from 'classnames'
import { HeaderSection } from '@components/header-section'
import { ArticlePreview } from '@components/article-preview'

import styles from './styles.module.scss'
import { EditorialWithHighlights } from 'types/editorial'

interface CoursesProps {
  className?: string
  section: EditorialWithHighlights
}

export const Courses: React.FC<CoursesProps> = ({ className, section }) => {
  return (
    <div className={classnames(styles.container, className)}>
      <HeaderSection sendTo="/noticias/editoria/cursos">
        <h2>Cursos</h2>
      </HeaderSection>
      <div className={styles.mainCourses}>
        {section.highlights.map(article => (
          <ArticlePreview
            key={article.path}
            articlePath={article.path}
            imageUrl={article.thumbnailImage.path}
            direction="top"
            title={article.title}
            description={article.shortContent}
            videoUrl={article.videoUrl}
            articleType={article.articleType}
          />
        ))}
      </div>
    </div>
  )
}
